import React from 'react';

import {
  Modal
} from '@salesforce/design-system-react';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

const BusinessInstructions = (props) => {
  const [isOpen, toggleIsOpen] = useToggle();

  return (
    <React.Fragment>
        <div 
          style={{ fontSize: '.8rem'}}>
            What is the <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={toggleIsOpen}>Business Challenge?</span>
        </div>
        <Modal
          isOpen={isOpen}
          onRequestClose={toggleIsOpen}
          heading="What is the Business Challenge?"
        >
          <section className="slds-p-around_medium">
          <div
              style={{ marginTop: '5px', marginBottom: '5px', fontSize: '1rem' }}
              className="slds-text-body_large"
            >
              Compelling stories get audiences to care. The first thing we need
              to do is determine the Business Challenge that will resonate best
              with your audience. Sound difficult? Don't worry, business
              challenges are made of a few simple components and we'll guide you
              through them below. If you get stuck, Astro's got your back! Check
              out the Q-Tips on the sidebar for additional guidance.
            </div>
            <div
              style={{ marginTop: '5px', marginBottom: '5px', fontSize: '1rem' }}
              className="slds-text-body_large"
            >
              We like to frame our business challenges as a “how might we...”
              statement that includes both the company goal and the methods that
              will solve for that goal. Here's an example: How might we drive
              top line revenue by streamlining operational processes and
              improving employee retention.
            </div>
            <div
              style={{ marginTop: '5px', marginBottom: '5px', fontSize: '1rem' }}
              className="slds-text-body_large"
            >
              Brainstorm this challenge with everyone and add in the company
              goal and methods as you go.
            </div>
          </section>
        </Modal>
    </React.Fragment>
  );
};

export default BusinessInstructions;
